import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpService } from './../services/http.service';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {

  @Output() renderRibbon: EventEmitter<number> = new EventEmitter();
 
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'POST, GET'
  });
  authCode: any;
  configData: any = [];
  configUnits: any;

  loggedInUser;
  isSubscriptionGranted: boolean = false;
  unitAuthorizedUrl: any = [];
  defaultUserGroup: string;
  subscription: string;
  environment: string;
  tagMovMsg;
  constructor(private readonly httpService: HttpService, public httpClient: HttpClient, public dialog: MatDialog) { }

  phtHeaders = new HttpHeaders({
    'Accept': '*/*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Headers': 'x-access-token,Content-Type',
    'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
  });

  xsrfTokenUrl = 'api/appsettings/GetToken';

  useCaseUrlsApi = 'api/appsettings/section/UseCaseUrls';
  currentUser: any;
  currentActiveUrl: any = [];
  isAuthorize: boolean = false;
  isActivate: boolean = true;
  currentActiveUser = {};
  defaultUser: any;
  /* URL's for APIMS screen */
  resourceListURL: string = "https://management.azure.com/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/providers/Microsoft.ApiManagement/service?api-version=2019-12-01";

/* URL for model Management screen */
  availableModelUrls = {
    'AIML': "https://management.azure.com/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.ApiManagement/service/r4cidi-apim-we-d/apis/ai-ml-api/operations?api-version=2019-12-01",
    'Surrogate': "https://management.azure.com/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.ApiManagement/service/r4cidi-apim-we-d/apis/surrogate-models-api/operations?api-version=2019-12-01",
    "Simulation": "https://management.azure.com/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.ApiManagement/service/r4cidi-apim-we-d/apis/simulator-api/operations?api-version=2019-12-01"
  };
  modelsExecURL = {
    'AIML': "https://r4cidi-apim-we-d.azure-api.net/simstore",
    'Surrogate': "https://r4cidi-apim-we-d.azure-api.net",
    "Simulation": "https://r4cidi-apim-we-d.azure-api.net/simulator-api"
  };
  modelOpsDesc = {
    'AIML': 'https://management.azure.com/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.ApiManagement/service/r4cidi-apim-we-d/apis/ai-ml-api/operations/',
    'Surrogate': 'https://management.azure.com/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.ApiManagement/service/r4cidi-apim-we-d/apis/surrogate-models-api/operations/',
    'Simulation': 'https://management.azure.com/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.ApiManagement/service/r4cidi-apim-we-d/apis/simulator-api/operations/'
  };
  modelListULR: string = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models";
  deleteModelURL: string = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models/";
  assetUrl = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/assets";
  registerModelURL = "https://westeurope.modelmanagement.azureml.net/modelmanagement/v1.0/subscriptions/63c9ab56-b584-4f1a-987a-a92be0864b5e/resourceGroups/RG-CIDI-WE-COMMON-SERVICES/providers/Microsoft.MachineLearningServices/workspaces/comm-mlrepo-we-d/models";

  userDetails: any;
  firstTimeLoad: boolean = true;
   
  currentUserDetails: any = [];
  isSwitchUser: boolean;
 
  gethttpHeader(bearerToken) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Methods': 'POST, GET',
        'Authorization': 'Bearer ' + bearerToken
      })
    };
    return httpOptions;
  }

  showAlert(model, data) {
     this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
  }

  openModelWindow(methodRef: (thisRef: any, result?: any) => void, thisRef, modelComponent, widthOfWindow, panelClassName, dataToPass) {
    {
      const dialogRef = this.dialog.open(modelComponent, {
        width: widthOfWindow,
        panelClass: panelClassName,
        data: dataToPass
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === true && methodRef != null) {
          methodRef(thisRef);
        }
        else if (result !== false) {
          methodRef(thisRef, result);
        }
        
      });
    }
  }

  getModelsDescriptions(methodRef: (data: any, thisRef: any) => void, thisRef, modelsDescUrl, accessToken) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Methods': 'POST, GET',
        'Authorization': 'Bearer ' + accessToken
      })
    };
    this.httpClient.get<any>(modelsDescUrl, httpOptions).subscribe((data: any): void => {
      methodRef(data, thisRef);
    }, (error: Error) => {
      thisRef.errorMessage = 'Error in fetching details, more details: ' + error.message;
      methodRef(null, thisRef);
    });
  }

  isNotNull(data: string) {
    if (data != undefined && data != null && data != "") {
      return true;
    } else {
      return false;
    }
  }
}
